export default "__VITE_ASSET__f1883YFv__"